import getKhattabat101CStore from "../../../../stores/khattabat-stores/101c-stores/index";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Conversation from "../conversation";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import ET3Div from "../../../../core/et3-div";

const ClientConversations = withLiteObserverAndTheme<{
  clientID: number;
}>((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;

  const { clientID } = props;

  const { oneOOneCId, oneOTwoConversationIds, shouldShowConversation } =
    getKhattabat101CStore(clientID);

  return !shouldShowConversation.get() ? null : (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="space-between"
      alignItems="center"
      withShadow={true}
      width={1450}
      height={0}
      color={colors.all.white}
      style={{
        borderRadius: 30 * unitX,
        overflow: "hidden"
      }}
      onClick={() => {}}
    >
      <Conversation conversationID={oneOOneCId.get()} />

      <Conversation conversationID={`${oneOOneCId.get()}_COMMENTS`} />

      {oneOTwoConversationIds.get().map((oneOTwoConversationId) => {
        return (
          <Conversation
            key={oneOTwoConversationId}
            conversationID={oneOTwoConversationId}
          />
        );
      })}
      <Et3Margin top={10} bottom={10} left={0} right={0} />
    </ET3Div>
  );
});

export default ClientConversations;
